<div class="flex-vertical gap-32">
  <h4>Administration fiches conseil</h4>
  <div class="flex-vertical oui-elevation-04 background-white rounded width-100pc padding-24 gap-40">
    <div class="flex-horizontal gap-16">
      <oui-button-toggle
        [options]="ficheTypeOptions"
        [control]="ficheTypeTogglecontrol"
        class="flex-2"></oui-button-toggle>
      <oui-select-filter
        class="flex-1"
        label="Enveloppes"
        type="list"
        panelDirection="left"
        listPlaceholder="Rechercher"
        [listOptions]="enveloppesFilterOptions"
        [control]="enveloppesFilterControl"></oui-select-filter>
      <oui-select-filter
        class="flex-1"
        label="Personnes"
        type="list"
        panelDirection="left"
        listPlaceholder="Rechercher"
        [listOptions]="investisseurTypeFilterOptions"
        [control]="investisseurTypeFilterControl"></oui-select-filter>
      <oui-select-filter
        class="flex-1"
        label="Natures"
        type="list"
        panelDirection="left"
        listPlaceholder="Rechercher"
        [listOptions]="natureFilterOptions"
        [control]="natureFilterControl"></oui-select-filter>
    </div>
    <app-fiche-config-table
      [inputData]="requestResult"
      (requestNewPage)="fetchAllConfigsAndApplyFilters()"
      [columnSelection]="columnSelection"
      [displayedColumns]="[
        'Type',
        'Enveloppe',
        'Habilitation',
        'Personne',
        'Nature',
        'Libelle',
        'Config',
        'Mise à jour'
      ]"
      (onRowClick)="onConfigClick($event)">
    </app-fiche-config-table>
  </div>
</div>
